import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

interface MainLayoutProps {
  children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const { pathname } = useLocation();
  // Only this workshop uses the full mobile width; its Retour Comité CE button
  // remains the navigation exit. Do not change other PRIsME layouts or guards.
  const isWorkshop = pathname === '/comite-ce/lac-epaule-septembre-2026' || pathname.startsWith('/comites/lac-a-epaule');
  return (
    <div className="flex min-h-screen bg-bz-light">
      <div className={isWorkshop ? 'hidden md:block' : undefined}><Sidebar /></div>
      <main className={isWorkshop ? 'min-w-0 w-full overflow-x-hidden md:ml-52 md:w-[calc(100vw-13rem)]' : 'ml-52 min-w-0 w-[calc(100vw-13rem)] overflow-x-hidden'}>
        {children}
      </main>
    </div>
  );
}
